import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
};

const forgetPasswordSlice = createSlice({
  name: "forgetPassword",
  initialState,
  reducers: {
    resetPasswordStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    resetPasswordSuccess: (state) => {
      state.isLoading = false;
    },
    resetPasswordFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    changeAdminPasswordStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    changeAdminPasswordSuccess: (state) => {
      state.isLoading = false;
    },
    changeAdminPasswordFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
  changeAdminPasswordStart,
  changeAdminPasswordSuccess,
  changeAdminPasswordFailure,
} = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;